<template>
  <div class="playground">
    <h1>Experimental Features</h1>
    <p>
      This is a playground for things we want to try out.
    </p>
    <h2>Size Difference</h2>
    <section>
      <div>
        <div>
          <v-img
            :src="require(`@/assets/pierre.png`)"
            :lazy-src="require(`@/assets/pierre-no-bkgd.png`)"
            class="raw-img"
          />
        </div>
        <h3>1.9MB</h3>
      </div>
      <div>
        <div class="background">
          <div class="background-image" :style="{
            'background-image': `url(${require('@/assets/pierre-no-bkgd.png')})`,
          }"/>
        </div>
        <h3>635kb</h3>
      </div>
    </section>
    <h2>Animations</h2>
    <section>
      <div>
        <div class="background anim1">
          <div class="background-image" :style="{
            'background-image': `url(${require('@/assets/pierre-no-bkgd.png')})`,
          }"/>
        </div>
        <h3>Jump around</h3>
      </div>
      <div>
        <div class="background anim2">
          <div class="background-image" :style="{
            'background-image': `url(${require('@/assets/pierre/pierre-body.png')})`,
          }"/>
          <div class="background-image hand" :style="{
            'background-image': `url(${require('@/assets/pierre/pierre-hand.png')})`,
          }"/>
        </div>
        <h3>Wave</h3>
      </div>
    </section>
    <section>
      <div>
        <div class="background anim3">
          <div class="eye left-eye"
            :style="{
              marginTop: `${y}px`,
              marginLeft: `${x}px`
            }"
          />
          <div class="eye right-eye"
            :style="{
              marginTop: `${y}px`,
              marginLeft: `${x}px`
            }"
          />
          <div class="background-image" :style="{
            'background-image': `url(${require('@/assets/pierre/pierre-body-eyes-closed.png')})`,
          }"/>
          <div class="background-image eyes" :style="{
            'background-image': `url(${require('@/assets/pierre/pierre-eyes.png')})`,
          }"/>
        </div>
        <h3>Blink</h3>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: 'PlaygroundView',
  mounted() {
    document.addEventListener('mousemove', this.updateMousePosition);
  },
  destroyed() {
    document.removeEventListener('mousemove', this.updateMousePosition);
  },
  data() {
    return {
      x: 0,
      y: 0,
    };
  },
  methods: {
    updateMousePosition(e) {
      const h = window.innerHeight/2;
      const w = window.innerWidth/2
      
      this.x = 5*(e.clientX - w)/w;
      this.y = 5*(e.clientY - h)/h;
    }
  }
}
</script>

<style lang="scss" scoped>
  .playground {
    padding-top: 40px;
  }

  @keyframes bounce {
    from {
      transform: translate3d(0, 10px, 0) scaleY(0.93) rotate(0deg);
    }
    to {
      transform: translate3d(0px, -40px, 0) scaleY(1) rotate(10deg);
    }
  }

  @keyframes bounceShadow {
    from {
      margin-left: -18%;
      width: 36%;
    }
    to {
      margin-left: -13%;
      width: 26%;
    }
  }

  @keyframes wave {
    from {
      transform: rotate(20deg);
    }
    to {
      transform: rotate(50deg);
    }
  }

  @keyframes blink {
    0% {
      transform: scaleY(1);
    }

    20% { transform: scaleY(1); }
    23% { transform: scaleY(0.1); }
    28% { transform: scaleY(0.1); }
    31% { transform: scaleY(1); }

    100% {
      transform: scaleY(1);
    }
  }

  @keyframes breathing {
    0% {
      transform: scale(0.98);
    }

    25% {
      transform: scale(1);
    }

    80% {
      transform: scale(0.98);
    }

    100% {
      transform: scale(0.98);
    }
  }

  .eye {
    filter: blur(1.5px);
    border-radius: 5px;
    height: 5px;
    width: 5px;
    position: absolute;
    background-color: white;
    top: 153.5px;
    z-index: 10;
    animation: blink 2s ease-out infinite normal;
  }

  .left-eye {
    left: 143.5px;
  }

  .right-eye {
    left: 233.5px;
  }
  
  section {
    display: flex;
    align-items: center;
    margin: auto;
    max-width: 800px;
    margin-bottom: 40px;
  }

  .raw-img {
    border-radius: 20px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
    height: 380px;
    width: 380px;
    margin: 10px;
  }
  
  .anim1 {
    .background-image {
      animation: bounce 0.5s;
      animation-direction: alternate;
      animation-timing-function: cubic-bezier(.5,1,0.05,.5);
      animation-iteration-count: infinite;
    }

    &::after {
      animation: bounceShadow 0.5s;
      animation-direction: alternate;
      animation-timing-function: cubic-bezier(.5,1,0.05,.5);
      animation-iteration-count: infinite;
    }
  }

  .anim3 {

    .background-image {
      transform-origin: 50% 90%;
      // animation: breathing 5s ease-out infinite normal;
    }

    .eyes {
      transform-origin: 0px 155px;
      animation: blink 2s ease-out infinite normal;
    }
  }

  .anim2 {
    .hand {
      animation: wave 1s;
      animation-direction: alternate;
      animation-timing-function: ease-in-out;
      animation-iteration-count: infinite;
    }  
  }

  .hand {
    margin-left: -10px;
    transform-origin: 130px 50%;
  }
  
  .background {
    background-color: #FFD023;
    border-radius: 20px;
    box-shadow: rgba(50, 50, 93, 0.25) 0px 30px 60px -12px, rgba(0, 0, 0, 0.3) 0px 18px 36px -18px;
    height: 380px;
    width: 380px;
    margin: 10px;
    overflow: hidden;
    perspective: 1000px;
    position: relative;
    z-index: 10;

    .background-image {
      background-position: center;
      background-size: cover;
      position: absolute;
      height: 100%;
      width: 100%;
    }
    
    &::after {
      background-color: #643E00;
      bottom: 12%;
      border-radius: 50%;
      content: "";
      filter: blur(20px);
      height: 25%;
      position: absolute;
      left: 50%;
      margin-left: -18%;
      transform: rotateX(85deg);
      width: 36%;
      z-index: -10;
    }
  }
</style>